import { render, staticRenderFns } from "./PendingOrdersStatusCmp.vue?vue&type=template&id=1e36ff0d&"
import script from "./PendingOrdersStatusCmp.vue?vue&type=script&lang=js&"
export * from "./PendingOrdersStatusCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports